<template>
  <div v-if="!isMobile">
    <material-check :list="list" :customStyle="customStyle" :activeIndex="activeIndex" @handle-click="handleClick"></material-check>
  </div>
  <div class="mobile-material-check" v-else>
    <div class="el-icon-goods" @click="drawer = true"></div>
    <el-drawer
      :size="136"
      :append-to-body="true"
      :with-header="false"
      :visible.sync="drawer"
      direction="ltr"
      custom-class="custom-drawer"
      :before-close="handleDrawerClose">
      <material-check :list="list" :activeIndex="activeIndex" @handle-click="handleClick"></material-check>
    </el-drawer>
  </div>

</template>

<script>
export default {
  name: 'MaterialCheckBox',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: [Number, String],
      default: 0
    },
    customStyle: String,
  },
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    handleClick(data) {
      this.drawer = false
      this.$emit('handle-click', data)
    },
    handleDrawerClose() {
      this.drawer = false
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-material-check {
  position: fixed;
  top: 200px;
  left: 15px;
  z-index: 22;
  .el-icon-goods {
    font-size: 40px;
    color: #005EFF;
  }
}
</style>